import axios from 'axios'

let baseUrl = 'https://prod.legacy.api.oatas.co/upstream'
let host = window.location.host
if (
  host === 'localhost:8080' ||
  host === 'localhost:8081' ||
  host === 'localhost:8082' ||
  host.startsWith('172.17.')
) {
  baseUrl = 'http://localhost:9080/upstream'
} else if (host.substring(0, 4) === 'dev.') {
  baseUrl = 'https://dev.legacy.api.oatas.co/upstream'
} else if (host === '10.0.0.141:8080') {
  baseUrl = 'http://10.0.0.141:9080/upstream'
}

let api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
})

// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    // if (
    //   response.data.hasOwnProperty("Result") &&
    //   response.data.Result == "No Internet"
    // ) {
    //   if (
    //     !router.currentRoute.meta.offlineAvailability &&
    //     router.currentRoute.name != null
    //   ) {
    //     router.push("/mobile-view/home");
    //   }
    // }
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default api
